import React from 'react'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import BiotrackNewItem from './BiotrackNewItem'
import {
  biotrackEnvironmentOptions as environmentOptions,
  biotrackModeOptions,
} from '../../utils/constants'

const BiotrackNewItemEditable = EditableHOCWrapper(BiotrackNewItem)

export default class BiotrackNewItemContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      editMode: false,
      data: {
        mode: biotrackModeOptions[0].value,
        environment: environmentOptions[0].value,
        shopId: this.props.shop.id,
        locationLicense: '',
        stateCode: this.props.shop.address.state,
        licenseUBI: '',
        userName: null,
        password: null,
        enabled: false,
        deliveryEnabled: false,
        enableSync: false,
      },
    }
  }

  onCancel = () => {
    //Clear data after cancel.
    this.setState({
      data: {
        mode: biotrackModeOptions[0].value,
        environment: environmentOptions[0].value,
        shopId: this.props.shop.id,
        locationLicense: '',
        stateCode: this.props.shop.address.state,
        licenseUBI: '',
        userName: null,
        password: null,
        enabled: false,
        deliveryEnabled: false,
        enableSync: false,
      },
    })
  }

  render() {
    const { editMode, data } = this.state

    const { onAddNewLocation } = this.props

    const facility = data
    return (
      <BiotrackNewItemEditable
        dataToEdit={facility}
        onSave={this.onSave}
        onCancel={this.onCancel}
        defaultEditMode={editMode}
        onAddNewLocation={onAddNewLocation}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Compliance/BiotrackNewItemContainer.js